/**
 * Styled Components - Created by cazarez on 08/02/18.
 */
import styled from 'styled-components'
import Row from 'antd/lib/row'
import Icon from 'antd/lib/icon'
import Divider from 'antd/lib/divider'
import arrowRightIcon from '../../assets/arrow.svg'
import { BLUE_SKY, GRAY_DARK } from '../../theme/colors'

interface DivProps {
  secondary?: boolean
}

export const Container = styled.div`
  background-color: #222;

  .cont {
    width: auto;

    @media (min-width: 800px) {
      width: 800px;
    }
  }
`

export const Title = styled.div`
  height: 33px;
  width: 281px;
  color: #5f6062;
  font-size: 24px;
  font-weight: bold;
  line-height: 33px;
  margin-top: 4px;
`

export const Subtitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 12px;
  line-height: 19px;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 12px;
  }
`

export const MenIcon = styled(Icon)`
  margin-left: 8px;
  font-size: 16px;
  color: ${BLUE_SKY};
`

export const WomenIcon = styled(Icon)`
  margin-left: 8px;
  font-size: 16px;
  color: deeppink;
`

export const YouthLabel = styled.div`
  font-size: 10px;
  color: #549c8c;
  margin-left: 5px;
  display: inline-block;
  vertical-align: bottom;
`

export const Text = styled.div`
  color: #fff;
`

export const CloseIcon = styled.img`
  position: absolute;
  right: 20px;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
`

export const StyledRow = styled(Row)`
  display: inline-flex;
  flex-flow: row;
  @media (max-width: 654px) {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`

export const PriceQuantityRow = styled(Row)`
  display: flex;
  margin-top: 8px;
  margin-bottom: -6px;
`
export const AvailablePrices = styled.div`
  width: 25%;
  @media (max-width: 654px) {
    margin-right: 12px;
  }
`

export const ProductInfContainer = styled.div`
  width: 329px;
  margin-bottom: 10px;
`
export const ProductInfoTitle = styled.div`
  display: flex;
  justify-content: space-between;
  height: 22px;
  width: auto;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`
export const DescriptionContent = styled.div`
  width: 329px;
  color: #5f6062;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0px;
  transition: visibility 0s, opacity 0.5s linear;
`

export const DetailsContent = styled.div`
  width: 329px;
  color: #5f6062;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0px;
  transition: visibility 0s, opacity 0.5s linear;
`

export const UpDownArrow = styled.img`
  &:hover {
    cursor: pointer;
  }
`

export const ArrowRight = styled.div`
  content: url(${arrowRightIcon});
  margin-left: 5px;
`

export const FullDetails = styled.div`
  display: flex;
  justify-content: center;
  right: 20px;
  bottom: 10px;
  &:hover {
    cursor: pointer;
  }
`

export const ColDiv = styled.div`
  display: block;
  box-sizing: border-box;
  width: ${({ secondary }: DivProps) => secondary ? '48%' : '52%'};
  @media (max-width: 654px) {
    width: 100%;
  }
`

export const DetailsList = styled.ul`
  padding: 10px 0px 0px 20px;
`

export const DetailsListItem = styled.li`
  margin-bottom: 15px;
`
export const StyledDivider = styled(Divider)`
  margin: 10px 0;
  border-bottom: 1px solid #bebebe;
`
export const Loading = styled.div`
  display: flex;
  justify-content: center;
  padding: 180px;
`

export const Description = styled.div`
  color: #5f6062;
  font-size: 13px;
  line-height: 23px;
  margin-top: -18px;
`

export const DescriptionRich = styled.div`
  width: 100%;
  margin-top: -10px;
  font-family: Avenir;
  line-height: 1.35;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/QuickView/styledComponents.tsx